import { IPublicClientApplication } from "@azure/msal-browser";

import { axiosGetRequest } from "../../api/ApiClient";
import { TipoNotificacaoEnum } from "../../model/Enums/TipoNotificacaoEnum";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";

const route = "/docente/v1/notificacoes";

function getNotifications(
    matricula_adp: string,
    tipo_notificacao: TipoNotificacaoEnum | string,
    instance: IPublicClientApplication,
    baixa_notificacao?: boolean
) {
    const userMatriculaAdp = GenericUtils.getUserAdp();

    let baixar = baixa_notificacao;
    if (matricula_adp !== userMatriculaAdp) {
        baixar = false;
    } else {
        baixar = baixa_notificacao === undefined ? true : baixa_notificacao;
    }

    const params = StringUtils.getQueryParams({
        tipo_notificacao,
        matricula_adp,
        baixa_notificacao: baixar,
    });

    return axiosGetRequest(
        `${route}${params}`,
        GenericUtils.getAccessTokenDocente(),
        instance
    );
}

export default {
    getNotifications,
};
